import React, { useEffect, useState } from "react";
import { Form, Input, Button, Icon, Divider, Tooltip } from "antd";
import { Vendor } from "../../../../../models/vendorPayouts";
import { Text3 } from "../../../../../styles";
import { alertify, handleApiExceptions } from "../../../../../app_methods";

const VendorFormFunc = (props) => {
  const { form, vendor } = props;
  const vendor_profile = vendor.vendor_profile || {};
  const { getFieldDecorator, validateFields } = form;
  const validations = Vendor.validations;
  const [isSaving, setIsSaving] = useState(false);
  const [bankFields, setBankFields] = useState([{
    account_number: "",
    account_ifsc: "",
    name_on_bank: "",
  }]);

  const addFormFields = () => {
    let bank_fields = [...bankFields];
    bank_fields.push({
      account_number: "",
      account_ifsc: "",
      name_on_bank: "",
    })
    setBankFields(bank_fields);
  };

  const removeFormField = async (index) => {
    const bank_fields = [...bankFields];
    if (!bank_fields[index].account_number == "") {
      const response = await vendor.deleteBankDetail({"uuid": bank_fields[index].id});
      if (!response.success) {
        handleApiExceptions(response);
        return;
      }
    }
    bank_fields.splice(index, 1);
    setBankFields(bank_fields);
  }

  const createVendor = async (values) => {
    if (vendor && vendor.id) {
      updateVendor(values);
      return;
    }
    setIsSaving(true);
    const response = await Vendor.create(values);
    if (!response.success) {
      setIsSaving(false);
      handleApiExceptions(response);
      return;
    }
    alertify(
      "Success",
      `Vendor ${vendor.is_edit ? "updated" : "created"} successfully.`,
      "success"
    );
    setIsSaving(false);
    props.onVendorSave();
  };

  const updateVendor = async (values) => {
    setIsSaving(true);
    const response = await vendor.update(values);
    if (!response.success) {
      setIsSaving(false);
      handleApiExceptions(response);
      return;
    }
    alertify("Success", `Vendor ${vendor.is_edit ? "updated" : "created"} successfully.`, "success");
    setIsSaving(false);
    props.onVendorSave();
  };

  const onSubmit = (e) => {
    e.preventDefault();
    validateFields((err, values) => {
      if (err) return;
      createVendor(values);
    });
  };

  const renderBasicForm = () => {
    return (
      <>
        <div className="row">
          <div className="col">
            {getFieldDecorator("id", {
              initialValue: vendor.id,
            })(<Input autoComplete="off" hidden />)}

            <Form.Item label="Name">
              {getFieldDecorator("name", {
                initialValue: vendor.name,
                rules: validations.name,
              })(<Input autoComplete="off" prefix={<Icon type="user" />} />)}
            </Form.Item>
          </div>
        </div>
        <div className="row">
          <div className="col">
            <Form.Item label="Email ID">
              {getFieldDecorator("email", {
                initialValue: vendor.email,
                rules: validations.email,
              })(
                <Input
                  autoComplete="off"
                  disabled={vendor.is_edit}
                  prefix={<Icon type="mail" />}
                />
              )}
            </Form.Item>
          </div>
          <div className="col">
            <Form.Item label="Phone No.">
              {getFieldDecorator("phone", {
                initialValue: vendor.phone,
                rules: validations.phone,
              })(<Input autoComplete="off" prefix={<Icon type="phone" />} />)}
            </Form.Item>
          </div>
        </div>
      </>
    );
  };

  const renderBankForm = () => {
    return (
      bankFields.length ?
        <>
          <div className="vp-bank">
            {bankFields.map((item, index) => renderBankDetailFields(item, index))}
            <div className="d-flex align-items-center justify-content-end">
              <Button type="link" onClick={() => addFormFields()} className="pl-0 pr-0" icon="plus"> Add More </Button>
            </div>
          </div>
        </> : null
    );
  };

  const renderBankDetailFields = (item, index) => {
    return (
      <div style={{ border: "1px solid #ddd", padding: 11, borderRadius: 10, marginBottom: 5, position: 'relative' }}>
        <div className="row">
          <div className="col">
            {getFieldDecorator(`bank_details[${index}]['id']`, {
              initialValue: item.id,
            })(<Input size="small" autoComplete="off" hidden />)}

            <Form.Item className="mb-0" label={`Account Number:`}>
              {getFieldDecorator(`bank_details[${index}]['account_number']`, {
                initialValue: item.account_number,
                rules: validations.account_number,
              })(
                <Input size="small"
                  readOnly={item.uuid}
                  autoComplete="off"
                  prefix={<Icon type="profile" />}
                />
              )}
            </Form.Item>
          </div>

          <div className="col">
            <Form.Item className="mb-0" label="IFSC">
              {getFieldDecorator(`bank_details[${index}]['account_ifsc']`, {
                initialValue: item.account_ifsc,
                rules: validations.account_ifsc,
                normalize: (input) => (input || "").toUpperCase(),
              })(
                <Input size="small"
                  autoComplete="off"
                  style={{ textTransform: "uppercase" }}
                  prefix={<Icon type="bank" />}
                />
              )}
            </Form.Item>
          </div>
        </div>

        <div className="row">
          <div className="col">
            <Form.Item label="Account Name" style={{ marginBottom: 0 }}>
              {getFieldDecorator(`bank_details[${index}]['name_on_bank']`, {
                initialValue: item.name_on_bank,
                rules: validations.name_on_bank,
              })(
                <Input size="small"
                  autoComplete="off"
                  disabled={vendor_profile.bank_status}
                  prefix={<Icon type="bank" />}
                />
              )}
            </Form.Item>
          </div>
        </div>
        {index || vendor.is_edit && index ? (
          <div className="row justify-content-end">
            <Tooltip title="Remove Bank Account">
              <Button
                style={{ position: 'absolute', top: 3, right: 3, color: "#ff4d4f" }}
                type="link"
                onClick={() => removeFormField(index)}
                className="pl-0"
                icon="delete"
              />
            </Tooltip>
          </div>
        ) : null}
      </div>
    );
  };

  useEffect(() => {
    setBankFields(vendor.is_edit ? vendor.vendor_profile.vendor_bank_details : [{
      account_number: "",
      account_ifsc: "",
      name_on_bank: "",
    }]);
  }, [vendor]);

  return (
    <Form onSubmit={onSubmit}>
      {renderBasicForm()}
      {renderBankForm()}
      <div className="w-100 d-flex justify-content-end mt-4">
        <Button htmlType="submit" type="primary" loading={isSaving}> Submit </Button>
      </div>
    </Form>
  );
};

const VendorForm = Form.create()(VendorFormFunc);
export { VendorForm };
